var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "sender-mail-address" } },
    [
      _c("div", { staticClass: "section-title" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("mail.senderAddressesSectionTitle")) +
            "\n        "
        ),
        _c(
          "div",
          {
            staticClass: "add-button",
            on: {
              click: function ($event) {
                return _vm.openModal()
              },
            },
          },
          [
            _c("span", { staticClass: "material-icons" }, [_vm._v("add")]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("mail.senderAddAddressButton")) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.data.length > 0
        ? _c("div", { staticClass: "sender-table" }, [
            _c("div", { staticClass: "table-header" }, [
              _c("div", { staticClass: "table-cell mail-cell" }, [
                _vm._v(_vm._s(_vm.$t("mail.senderTableMailAddress"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-cell" }, [
                _vm._v(_vm._s(_vm.$t("mail.senderTableForwarding"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-cell" }, [
                _vm._v(_vm._s(_vm.$t("mail.senderTableVerifiedCol"))),
              ]),
              _vm._v(" "),
              _vm.isCanBeChangeDefault(_vm.selectedMailAddress)
                ? _c(
                    "div",
                    { staticClass: "table-cell" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("mail.senderTableDefaultCol")) +
                          "\n                "
                      ),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.senderDefaultMailTooltip"),
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "material-icons info-icon" },
                            [_vm._v("info")]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "table-cell actions-cell" }, [
                _vm._v(_vm._s(_vm.$t("mail.senderActionsColumn"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-body" },
              _vm._l(_vm.data, function (address) {
                return _c(
                  "div",
                  { key: address._id, staticClass: "table-row" },
                  [
                    _c(
                      "div",
                      { staticClass: "table-cell mail-cell" },
                      [
                        _c("a-tooltip", { attrs: { title: address.mail } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(address.mail) +
                              "\n                    "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "table-cell" },
                      [
                        address.isForward
                          ? _c("div", { staticClass: "status-badge success" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("verified"),
                              ]),
                              _vm._v(
                                "\n                        Doğrulandı\n                    "
                              ),
                            ])
                          : _c(
                              "a-tooltip",
                              {
                                attrs: {
                                  title:
                                    "Yönlendirme işleminden sonra otomatik olarak güncellenecektir.",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "status-badge warning" },
                                  [_vm._v("Yönlendirilmedi")]
                                ),
                              ]
                            ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-cell" }, [
                      !address.isSenderMail ||
                      (!!address.isSenderMail && address.isSenderVerified)
                        ? _c("div", { staticClass: "status-badge success" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("verified"),
                            ]),
                            _vm._v(
                              "\n                        Doğrulandı\n                    "
                            ),
                          ])
                        : _c("div", { staticClass: "status-badge warning" }, [
                            _c("span", [_vm._v("Doğrulanmadı")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "material-icons refresh-icon",
                                on: {
                                  click: function ($event) {
                                    return _vm.isVerifiedControl(address)
                                  },
                                },
                              },
                              [_vm._v("refresh")]
                            ),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-cell" }, [
                      _vm.isCanBeChangeDefault(address)
                        ? _c("input", {
                            attrs: {
                              disabled: address.isSenderMail
                                ? address.isSenderVerified === false
                                : address.isVerified === false,
                              type: "radio",
                            },
                            domProps: { checked: address.isDefault },
                            on: {
                              click: function ($event) {
                                return _vm.changeDefaultMail(address)
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "table-cell actions-cell" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: {
                              danger: "",
                              ghost: "",
                              disabled: !address.isSenderMail,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteSenderMail(address)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("mail.senderDelete")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-footer" },
              [
                _c("a-pagination", {
                  attrs: {
                    current: _vm.currentPage,
                    pageSize: _vm.perPage,
                    total: _vm.total,
                    pageSizeOptions: _vm.pageSizes,
                    showSizeChanger: "",
                  },
                  on: {
                    change: _vm.pageChange,
                    showSizeChange: _vm.onShowSizeChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _c(
            "div",
            { staticClass: "empty-state" },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("mail_outline"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "empty-text" }, [
                _vm._v(_vm._s(_vm.$t("mail.senderEmptyNoAddresses"))),
              ]),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  attrs: { primary: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openModal()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("mail.senderAddAddressButton")))]
              ),
            ],
            1
          ),
      _vm._v(" "),
      _vm.isCreateModal
        ? _c(
            "Modal2",
            {
              staticClass: "sender-mail-modal",
              attrs: {
                title: _vm.$t("mail.senderModalAddTitle"),
                "show-footer": false,
                "show-title": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.isCreateModal = false
                },
              },
            },
            [
              _vm.current === 0
                ? _c("div", [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("mail.senderModalAddTitle"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-form" }, [
                      _c("div", { staticClass: "form-description" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("mail.senderModalDescription")) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "mailAddress" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("mail.senderMailAddressFieldLabel"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "input-container",
                            class: {
                              error: _vm.mailAddress && !_vm.isValidEmail,
                            },
                          },
                          [
                            _c("span", { staticClass: "input-icon" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("mail"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mailAddress,
                                  expression: "mailAddress",
                                },
                              ],
                              staticClass: "form-input",
                              attrs: {
                                id: "mailAddress",
                                placeholder: _vm.$t(
                                  "mail.integrationEmailExamplePlaceholder"
                                ),
                              },
                              domProps: { value: _vm.mailAddress },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.verifySenderMail.apply(
                                    null,
                                    arguments
                                  )
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.mailAddress = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.mailAddress && !_vm.isValidEmail
                          ? _c("div", { staticClass: "error-message" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("mail.integrationInvalidEmail")
                                  ) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modal-footer" },
                        [
                          _c(
                            "SupsisButton",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.isCreateModal = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("mail.cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                disabled: !_vm.isValidEmail,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.verifySenderMail()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("mail.senderVerify")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.current === 1
                ? _c("div", [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h3", [
                        _vm._v(
                          _vm._s(_vm.$t("mail.senderForwardingVideoTitle"))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-video-container" },
                      [_c("gif-player", { attrs: { src: _vm.getGifSrc() } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-footer" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: { primary: "" },
                            on: {
                              click: function ($event) {
                                _vm.isCreateModal = false
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("mail.modalOk")))]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }